<template>
  <div class="jjfa_all">
    <div class="jjfa_nei">
        <div class="jjfa_img">
          <el-image
            style="width: 1080px; height: 740px"
            :src="imgUrl"
            :fit="contain"></el-image>
        </div>
        <div class="jjfa_text">
            <div class="jjfa_text_tou">
              <div class="jjfa_text_tou_1">解决方案</div>
              <div class="jjfa_text_dd" @click="jjfaCK">
                <div class="jjfa_text_dd_1">查看更多</div>
                <div ><i class="el-icon-right"></i></div>
              </div>
            </div>

          <div class="jjfa_text_count">
            {{itemCount}}
          </div>
          <div class="jjfa_text_tatil" v-for="item in itemData" @click="selectItem(item.index)" v-on:mouseenter="handleMouseEnter(item.index)" :style="{backgroundColor:item.back}">
            <div class="jjfa_text_tatil_1" :style="{color:item.p1}" >{{item.text1}}</div>
            <div class="jjfa_text_tatil_2"><i class="el-icon-right"></i></div>
          </div>
        </div>

    </div>
  </div>
</template>
<style>
.jjfa_text_tatil_2{
  margin-right: 20px;
}
.jjfa_text_tatil_1{
  font-family: SourceHanSansCN;
  font-size: 24px;
  color: #000000;
  letter-spacing: 0;
  text-align: justify;
  margin-left: 20px;
}
.jjfa_text_tatil{
  width: 442px;
  height: 128px;
  display: flex;
  margin-top: 10px;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
}
.jjfa_text{
  margin-left: 30px;
}
.jjfa_text_count{
  font-family: SourceHanSansCN;
  font-size: 14px;
  color: #666666;
  letter-spacing: 0;
  text-align: justify;
  line-height: 22px;
  margin-top: 20px;
  margin-bottom: 20px;
}
.jjfa_text_dd_1{
  font-family: SourceHanSansCN;
  font-size: 14px;
  color: #666666;
  letter-spacing: 0;
  text-align: justify;
}
.jjfa_text_tou_1{
  font-family: SourceHanSansCN;
  font-size: 30px;
  color: #333333;
  letter-spacing: 0.64px;
  text-align: justify;
}
.jjfa_text_dd{
  display: flex;
  cursor: pointer;
}
.jjfa_text_tou{
  display: flex;
  margin-top: 50px;
  align-items: center;
  justify-content: space-between;

}
.jjfa_nei{
  width: 1500px;
  /*height: 678px;*/
  display: flex;
}
.jjfa_all{
  width: 1920px;
  /*height: 860px;*/
  display: flex;
  justify-content: left; /* 水平居中 */
  align-items: flex-end; /* 垂直居中 */
  margin-top: 50px;
  margin-bottom: 50px;

}
</style>
<script>
export default {
  name: "jjfa",
  data() {
    return{
      itemCount:"建设区域乃至全国领先的口腔舒适化激光诊疗中心，打造集医疗、科研、教学为一体的现代化激光诊疗平台。开展激光诊疗技术的临床研究和应用推广，形成具有自主知识产权的技术成果，推动口腔医学技术创新与发展。",
      colorData:{
        back:"#5daf34",
        p1:"#FFFFFF"
      },
      imgUrl:"https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg",
      itemData:[
        {
          index:1,
          text1:"针对医院（科室）",
          imgUrl:"http://116.62.38.250//image/sy/jjfa.jpg",
          back:"#5daf34",
          p1:"#FFFFFF",
          path:"dyy"
        },
        {
          index:2,
          text1:"针对医生",
          imgUrl:"http://116.62.38.250//image/sy/jjfa.jpg",
          back:"#5daf34",
          p1:"#FFFFFF",
          path:"dys"
        },
        {
          index:3,
          text1:"针对患者",
          imgUrl:"http://116.62.38.250//image/sy/jjfa.jpg",
          back:"#5daf34",
          p1:"#FFFFFF",
          path:"dhz"
        }
        // ,
        // {
        //   index:4,
        //   text1:"服务公立民营XXX",
        //   imgUrl:"http://116.62.38.250//image/sy/jjfa.jpg",
        //   back:"#5daf34",
        //   p1:"#FFFFFF"
        // }
      ]
    }
  },
  mounted() {
    let that = this;
    that.init();
  },
  methods:{
    init(){
      let that = this;
      for(let index in that.itemData){
        let itemBom = that.itemData[index];
        if(itemBom.index === 1){
          that.imgUrl = itemBom.imgUrl;
          itemBom.back = "#5daf34"
          itemBom.p1 = "#FFFFFF"
        } else {
          itemBom.back = "#FFFFFF"
          itemBom.p1 = "#000000"
        }

      }

    },
    selectItem(indexx){
      let that = this;
      for(let index in that.itemData){
        let itemBom = that.itemData[index];
        if(itemBom.index == indexx){
          that.imgUrl = itemBom.imgUrl;
          itemBom.back = "#5daf34"
          itemBom.p1 = "#FFFFFF"
          this.$router.push('/companyProfile?path='+itemBom.path);
        } else {
          itemBom.back = "#FFFFFF"
          itemBom.p1 = "#000000"
        }

      }
    },
    handleMouseEnter(indexx){
      let that = this;
      for(let index in that.itemData){
        let itemBom = that.itemData[index];
        if(itemBom.index == indexx){
          // that.imgUrl = itemBom.imgUrl;
          itemBom.back = "#5daf34"
          itemBom.p1 = "#FFFFFF"
        } else {
          itemBom.back = "#FFFFFF"
          itemBom.p1 = "#000000"
        }

      }
    },
    jjfaCK(){
      this.$router.push('/companyProfile');
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/image/jjfa.vue